import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { initDB } from './db';
import { useAuthStore } from './stores/authStore';
import { supabase } from './utils/supabase';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

// Initialize database and load data
initDB()
  .then(async () => {
    // ページ初期ロード/リロード時のセッションチェックログ
    try {
      const { data, error } = await supabase.auth.getSession();
      if (error) {
        console.error("Supabase getSession error on initial load:", error);
      } else if (!data.session) {
        console.log("セッション切れてる (初期ロード時)");
      } else {
        console.log("ログイン中ユーザー (初期ロード時):", data.session.user.email);
      }
    } catch (sessionError) {
      console.error("Error checking session on initial load:", sessionError);
    }

    // Initialize authentication state properly
    await useAuthStore.getState().initializeAuth();

    // データロードはApp.tsxで一元管理するため、ここでは認証初期化のみ実行
    console.log('■■認証初期化完了、データロードはApp.tsxに委譲■■');

    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  })
  .catch(error => {
    console.error('Failed to initialize application:', error);
    root.render(
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">
            エラーが発生しました
          </h1>
          <p className="text-gray-600">
            アプリケーションの初期化に失敗しました。
            <br />
            ページを再読み込みしてください。
          </p>
        </div>
      </div>
    );
  });